import escapeRegExp from 'lodash/escapeRegExp';

// Derived from JQLLexer#VALID_UNQUOTED_CHARS
var CHARS_TO_QUOTE = new RegExp("[\\s".concat(escapeRegExp("\"'=!<>()~,[]|&{}*/%+^$#@?;"), "]"));

/**
 * Quote the provided JQL string (and escape any existing quotes) if the input string uses reserved characters.
 *
 * @param jqlString String to sanitise
 */
export var sanitiseJqlString = function sanitiseJqlString(jqlString) {
  if (CHARS_TO_QUOTE.test(jqlString)) {
    return "\"".concat(jqlString.replace(/"/g, '\\"'), "\"");
  }
  return jqlString;
};